<!-- 设置 -->
<template>
    <div class="card">
        <Form :model="form_item" label-position="right" :label-width="110">
            <div class="title-container">代理商设置</div>
            <FormItem label="门店审核：">
                <i-switch
                    v-model="form_item.review"
                    size="large"
                    true-color="#FF761D "
                    :true-value="1"
                    :false-value="0"
                >
                    <span slot="open">开启</span>
                    <span slot="close">关闭</span>
                </i-switch>
                <Tooltip max-width="250" placement="right" theme="light">
                    <Icon
                        class="tip-container"
                        type="md-help-circle"
                        size="16"
                        color="#FF761D "
                    />
                    <div slot="content">
                        <p>
                            开启后，代理商创建的门店需要经过平台审核，才能正常使用。
                        </p>
                    </div>
                </Tooltip>
            </FormItem>
        </Form>
        <div class="footer-container">
            <Button class="theme-bc theme-default-color" @click="goSubmit"
                >确定</Button
            >
        </div>
    </div>
</template>

<script>
import { account_info, account_store_review } from "@/api/index";
export default {
    data() {
        return {
            form_item: {
                review: 0,
            },
        };
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        getInfo() {
            account_info()
                .then((res) => {
                    this.form_item.review = res.data.store_review;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goSubmit() {
            account_store_review()
                .then((res) => {
                    this.getInfo();
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 4px;
    height: 100%;
    position: relative;
}
.title-container {
    margin-bottom: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #484e66;
}
.tip-container {
    margin-left: 24px;
    cursor: pointer;
}
.footer-container {
    margin-top: 24px;
    padding: 24px 24px 0 0;
    border-top: 1px solid #f7f8fa;
    position: absolute;
    bottom: 24px;
    left: 0;
    right: 0;
    text-align: center;
}
</style>